// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2p_OH","rootSuccess":"CompleteLink_rootSuccess__342n2","rootFailure":"CompleteLink_rootFailure__pJifV","isDisabled":"CompleteLink_isDisabled__2j7pM"};